import LineInterface from 'app/interfaces/LineInterface';
import {lineGamer} from 'app/lines/lineGamer';
import {isAdvantageLine} from 'app/lines/isAdvantageLine';
import {userStore} from 'app/store/global';

// eslint-disable-next-line max-statements
export const tableNick = (line: LineInterface, gamerNum: number): string => {
    if (isAdvantageLine(line)) {
        return line[`gamer_short_text_${gamerNum}`];
    }

    const gamer = lineGamer(line, gamerNum);

    if (!gamer) {
        if (userStore.user.experimental_features) {
            console.log('tableNick error: gamer is undefined in default case', {gamerNum, line});
        }
        return '';
    }

    const siteLang = userStore.user.site_lang;

    return gamer.nick_langs && gamer.nick_langs[siteLang] || gamer.nick;
};
